<template>
  <div class="store-item">
    <img v-if="item.logoUrl" :src="item.logoUrl" alt="" class="img" />
    <img v-else src="@/assets/img/icon_store.png" alt="" class="img" />
    <div class="store-content">
      <div class="content-flex" style="justify-content: space-between">
        <div class="name">{{ item.storeName }}</div>
        <div class="distance">{{ item.distance }}km</div>
      </div>
      <div class="content-flex">
        <img src="@/assets/img/icon_store_phone.png" class="icon" />
        <div>{{ item.storePhone }}</div>
      </div>
      <div class="content-flex">
        <img src="@/assets/img/icon_store_position.png" alt="" class="icon" />
        <div class="view-text">{{ item.address }}</div>
      </div>
      <div class="content-flex bottom">
        <a class="call" :href="'tel:' + item.storePhone">电话联系</a>
        <div class="navi" @click="gotoNavigate">导航前往</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    //导航
    gotoNavigate() {
      const end = [this.item.lng, this.item.lat, this.item.storeName].join(
        ","
      );
      // callnative 尝试调起高德地图APP并在APP中查看，0表示不调起，1表示调起 微信、QQ内置浏览器无法成功调起
      window.location.href = `https://uri.amap.com/navigation?from=&to=${end}&callnative=1`;
    },
  },
};
</script>

<style lang="less" scoped>
.store-item {
  font-size: 15px;
  color: #383838;
  display: flex;
  flex-direction: row;
  background: #ffffff;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 5px;
  width: 7.1rem;

  .img {
    width: 72px;
    height: 72px;
    margin-top: 15px;
    margin-left: 10px;
  }

  .store-content {
    display: flex;
    flex-flow: column;
    justify-content: center;
    font-size: 13px;
    padding: 10px 10px 0 10px;
    border-radius: 5px;
    flex: 1;
    width: 4.3rem;

    .content-flex {
      display: flex;
      flex-flow: row;
      padding-bottom: 8px;
      align-items: center;
    }

    .content-flex-row {
      display: flex;
      flex-flow: row;
      padding-bottom: 8px;
      align-items: center;
    }

    .name {
      word-break: break-all;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      font-size: 15px;
      font-family: PingFangSC-Medium;
      font-weight: bold;
    }

    .view-text {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-wrap: break-word;
    }

    .icon {
      width: 12px;
      height: 12px;
      padding-right: 6px;
    }

    .distance {
      color: #999999;
      font-size: 11px;
      justify-content: space-between;
      text-align: right;
      max-width: 1.2rem;
    }

    .bottom {
      justify-content: space-between;
      border-top: 1px solid #e6e6e6;
      padding-top: 8px;
      padding-bottom: 10px;
      color: var(--theme-color);

      .navi {
        background: url(~@/assets/img/icon_store_navi.png) no-repeat;
        background-size: 15px 15px;
        line-height: 18px;
        padding-right: 4px;
        background-position: left center;
        padding-left: 16px;
      }

      .call {
        background: url(~@/assets/img/icon_store_call.png) no-repeat;
        background-size: 15px 15px;
        background-position: 0 2px;
        padding-left: 16px;
        line-height: 18px;
        color: var(--theme-color);
        background-position: left center;
      }
    }
  }
}
</style>
